var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from "react";
import { TitledDescription } from "../CardOptions/CardOptions";
import styles from "./CautionCard.module.scss";
import WarningSign from "../../icons/WarningSign";
import InfoBar from "../InfoBar";
import { InfoBarType } from "@eightfold.ai/octuple";
import CheckBox from "../CheckBox/CheckBox";
import { FilterContext } from "../../providers/FilterProvider";
import { AvailableFilters, getEntity } from "../../common/filters";
import { useClient } from "../../hooks/client";
import { useGetDataFiltersQuery } from "../../store/api/core";
import { useReloadableReportData } from "../../providers/ReloadableReportDataProvider";
import { isCohort, useDynamicOptions } from "../Filters/Filters";
export var multipleJourneysWithSingleLevelSelected = {
    title: "Caution - Mixed Assessment Journeys",
    description: (_jsxs(_Fragment, { children: ["This report includes leaders assessed under different conditions, which impacts scores and proper interpretation.", _jsx("br", {}), "More specifically:", _jsx("ul", __assign({ className: styles.cautionList }, { children: _jsxs("li", { children: [_jsx("strong", { children: "Mixed assessment journeys:" }), " Context differences are problematic, as cross-journey comparisons are unreliable and aggregate results often misleading."] }) })), "We recommend filtering to a single journey for clearer insights."] })),
};
var useNonCustomOptions = function () {
    var _a;
    var getFilters = useContext(FilterContext).getFilters;
    var client = useClient();
    var filters = getFilters();
    var filterOptionsData = useGetDataFiltersQuery({ clientId: client.clientId || "", filters: filters }, { shouldSkipCall: function () { return !client.clientId; } });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var availableOptionsData = (_a = filterOptionsData === null || filterOptionsData === void 0 ? void 0 : filterOptionsData.data) === null || _a === void 0 ? void 0 : _a.data;
    return availableOptionsData;
};
var useCustomOptions = function () {
    var response = useDynamicOptions();
    var options = Object.entries((response === null || response === void 0 ? void 0 : response.options) || {}).reduce(function (current, _a) {
        var _b;
        var key = _a[0], options = _a[1].options;
        return (__assign(__assign({}, current), (_b = {}, _b[key] = options, _b)));
    }, {});
    return options;
};
export var useCountInfo = function () {
    var _a, _b;
    var getFilters = useContext(FilterContext).getFilters;
    var filters = getFilters();
    var availableOptionsData = (isCohort() ? useCustomOptions : useNonCustomOptions)();
    var availableJourneyCount = ((_a = availableOptionsData === null || availableOptionsData === void 0 ? void 0 : availableOptionsData[getEntity(AvailableFilters.AssessmentJourney)]) === null || _a === void 0 ? void 0 : _a.length) || 0;
    var journeyCount = ((_b = filters === null || filters === void 0 ? void 0 : filters[getEntity(AvailableFilters.AssessmentJourney)]) === null || _b === void 0 ? void 0 : _b.length) || 0;
    var effectiveJourneyCount = journeyCount === 0 ? availableJourneyCount : journeyCount;
    return {
        values: { journey: journeyCount },
        effectives: { journey: effectiveJourneyCount },
        cautionMessage: effectiveJourneyCount >= 2
            ? multipleJourneysWithSingleLevelSelected
            : null,
    };
};
export var CautionCard = function (_a) {
    var className = _a.className;
    var _b = useReloadableReportData(), setData = _b.setData, data = _b.data;
    var cautionMessage = useCountInfo().cautionMessage;
    if (!cautionMessage) {
        return _jsx(_Fragment, {});
    }
    var title = cautionMessage.title, description = cautionMessage.description;
    var handleCheckboxChange = function (e) {
        var target = e.target;
        var newChecked = target.checked;
        setData(function (previous) { return (__assign(__assign({}, previous), { filterCheckOverride: newChecked })); });
    };
    return (_jsx("div", __assign({ className: className }, { children: _jsxs("div", __assign({ className: styles.cautionCard }, { children: [_jsx("div", __assign({ className: styles.warningSign }, { children: _jsx(WarningSign, {}) })), _jsxs("div", __assign({ className: styles.content }, { children: [_jsx(TitledDescription, { title: title, description: _jsx("span", __assign({ className: styles.cautionDescription }, { children: description })) }), _jsx("div", __assign({ className: styles.checkboxContainer }, { children: _jsx(CheckBox, { value: "continue-anyway", label: "I want to continue anyway", checked: data.filterCheckOverride || false, onChange: handleCheckboxChange }) })), _jsx("div", __assign({ className: styles.errorContainer }, { children: _jsx(InfoBar, { content: "Check the box above to continue", type: InfoBarType.disruptive }) }))] }))] })) })));
};
